import {Component, OnInit} from '@angular/core';
import {LayoutService} from './service/app.layout.service';
import {UserMenuService} from "../auth/login/services/usermenu.service";
import {LoginServices} from "../auth/login/services/login.service";

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {
    constructor(public layoutService: LayoutService, public userMenuService: UserMenuService, public loginServices:LoginServices) {
    }
    ngOnInit() {
        console.log(`ngOnInit() ->` + this.constructor.name)
        console.log(`this.loginServices.rutasCompletas(): ${JSON.stringify(this.userMenuService.rutas().length)}`);
    }
}
